export default __webpack_public_path__ + "static/media/wrong-code.85f26f92.png";